import type { JobStatusEnum } from './job.types';

export const EventTypes = {
    CitationsDocumentAdded: 'citations-document-added',
    CitationsDocumentImportCompleted: 'citations-document-import-completed',
    CitationsDocumentDeleted: 'citations-document-deleted',
    ReviewUpdated: 'review-updated',
    SystemJobStatusChanged: 'system-job-status-changed',
} as const;

export type SystemEventResponse = {
    id: string;
    eventType: string;
    scope: string;
    scopeId: string;
    payload: unknown;
    triggeredByUserId: string | null;
    originId: string | null;
    created: string;
};

export type GetSystemEventsResponse = {
    events: SystemEventResponse[];
    cursor: string | null;
};

export type SystemJobStatusChangedPayload = {
    jobId: string;
    scope: string;
    scopeId: string;
    safeName: string;
    status: JobStatusEnum;
};

export type CitationsDocumentAddedPayload = {
    documentId: string;
    fileName: string;
};

export type CitationsDocumentImportCompletedPayload = {
    documentId: string;
    recordCount: number;
};

export type CitationsDocumentDeletedPayload = {
    documentId: string;
};
